module.exports = __webpack_public_path__ + "img/PuckbyQrespi-poster-m.567c9a52.jpg";